import axios from "axios";
import isEmpty from "lodash/isEmpty";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

export const salesCodesLoading = () => {
	return {
		type: "SALES_CODES_LOADING"
	};
};

export const salesCodesError = err => {
	return {
		type: "SALES_CODES_ERROR",
		err
	};
};

export const salesCodesSuccess = payload => {
	return {
		type: "SALES_CODES_SUCCESS",
		payload: payload
	};
};

export function checkSaleCodesAvailable() {
	return (dispatch, getState) => {
		dispatch(salesCodesLoading());

		let AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };

		return axios
			.get(REACT_APP_API_URL + "cart-code/", { headers: AUTH_HEADER })
			.then(response => {
				// Error explicitly set
				if (!isEmpty(response.data.errors)) {
					dispatch(salesCodesError(response.data.errors));

					// Error status
				} else if (!!response.data.status && response.data.status !== 200) {
					dispatch(salesCodesError({ general: response.data.message }));

					// Success
				} else {
					dispatch(salesCodesSuccess(response.data));
				}
			})
			.catch(err => {
				console.log("getSalesCodes error:", err.response.statusText);
				dispatch(salesCodesError({ general: err.response.statusText }));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/saleCodes.js